// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2849":"bbcba40c93eb7733","4052":"7bcc184c8f0db6cf"}[chunkId] + ".css";
};